import { createContext, useContext } from "react";
import { Currency } from "../../types/Currency/Currency";

export interface CurrencyContextType {
  currencies?: Currency[] | null;
  selectedCurrency?: Currency | undefined;
  setSelectedCurrency: (currency: Currency | undefined) => void;
}
const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined
);

const useCurrencyContext = () => {
  // get the context
  const context = useContext(CurrencyContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useCurrencyContext was used outside of its Provider");
  }

  return context;
};

export { CurrencyContext, useCurrencyContext };
